<template> 
    <div class="controls">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
        </head>  
        <button class="button" v-if="!deviceCharacteristic"
                :class="{'is-warning': !deviceCharacteristic, 'is-success' : deviceCharacteristic }" 
                :disabled="deviceCharacteristic"
                id="pair" v-on:click="connect">Connect tester</button>

        <div v-if="deviceCharacteristic && isMultimetrOn">
            <div class="label is-warning">
                Multimetr mode. Please switch off multimetr mode by clicking at Stop Multimetr button here.
            </div>
            <button class="button"                
                id="sendButton" 
                :disabled="sendLocked"
                v-on:click="StopMultimetr">Stop Multimetr</button>    
        </div> 
        <div v-if="deviceCharacteristic && !isMultimetrOn">
            <div class="filed">
                <label class="label">Name or S/N</label>
                <div class="control">
                    <input class="input" type="text" v-model="sampleName" placeholder="sample name"> 
                </div>
            </div>
            <div class="filed">
                <label class="label">Comment</label>
                <div class="control">
                    <input class="input" type="input" v-model="sampleComment" placeholder="comment">  
                </div>
            </div>
            <div class="filed">
                <div class="control">
                    <input type="checkbox" name="useSensor" id="useSensor" v-model="useSensor">    
                    <span class="field"> Use sensor</span>
                </div>
            </div>
            <div class="filed">
                <label class="label">Panel temperature, C</label>
                <div class="control">
                     <input class="input" type="input"
                        v-model="avarageTemperature"
                        :disabled="useSensor " 
                        placeholder="temperature">  
                </div>
            </div>

            <div class="filed">
                <label class="label">Average light, W/m2</label>
                <div class="control">
                     <input class="input" type="input"
                        v-model="avarageLight"
                        :disabled="useSensor " 
                        placeholder="light">
                </div>
            </div>

           <div class="filed">
                <label class="label">Tester temperature, C</label>
                <div class="control">
                     <input class="input" type="input"
                        :class="{'is-danger' : overheat, 'is-warning' : heatsinkTemperature > 45}"
                        v-model="heatsinkTemperature"
                        :disabled="true" 
                        placeholder="tester temperature">  
                </div>
            </div>

            <label class="label is-danger" v-if="overheat">Tester is overheated, please wait.</label>
            
            <button class="button"
                v-if="!sendLocked" 
                id="sendButton" 
                :disabled="sendLocked || overheat"
                v-on:click="send">Test</button>

            <div class="notification is-warning" v-if="errorMessage">
               Warning: {{errorMessage}}
            </div>

            <figure class="image is-128x128" v-if="deviceCharacteristic && sendLocked">
                <img src="..\assets\spinner.gif">
            </figure>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import { dataService } from '../shared/data';
import { calculator } from '../shared/calculator';
import { stopMultimetrCommand } from '../shared/config';
export default {
    name: "ControlPanel",
    data() {
        return {
            sampleName:"",
            sampleComment: "",
            //sampleTemperature: undefined,
            serviceUUID : "0000ffe0-0000-1000-8000-00805f9b34fb",
            characteristicId : "0000ffe1-0000-1000-8000-00805f9b34fb",
            deviceCharacteristic : null,
            endChar : '&',   
            message: '',  
            locked: false,
            useLightFromSensor : true,
            useSensor : true,
            avarageLight: undefined,
            avarageTemperature: undefined,
            heatsinkTemperature: undefined,

            lights: [],
            iCell: undefined,
            tCell: undefined,

            overheat : false,
            tHeatsinkMax : 50,

            isMultimetrOn: false,

            errorMessage : "",
        }
    },
    mounted () {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been rendered
            // const button = document.getElementById('pair');
            // button.addEventListener('pointerup', function () {
                // this.connect();
            // });
        })
    },
    computed: {
        sendLocked() {
            return this.locked || !this.deviceCharacteristic;
        },
        ...mapState(['panelTemperature','light']),  
        ...mapGetters(['getAverageLight','getAverageTemperature', 'getIsSensorConnected', 'getSensorLights']),       
    },
    methods: {
        ...mapActions(['addSampleAction','clearLightsAction','clearPanelTemperaturesAction','setSensorReadingAction']),
        async onNewMessage(msg) {
            if (!msg)
                return;
            const index = msg.indexOf(this.endChar);
            if (index >= 0) {
                let newMsg = msg.substring(0, index);
                this.message += newMsg;
                if (index === msg.length - 1) {
                    msg = "";
                }
                else {
                    msg = msg.substring(index + 1, msg.length);
                }
                // TODO: handle message
                console.log(this.message);
                const sensorMessageStart = "Sns;";  
                const ivMessageStart = "i;I;U";  
                const overheatMessage = "hot";
                if (this.stringContains(this.message,overheatMessage))
                {
                    //TODO: show warning;
                    this.overheat = true;
                    this.locked = false;
                }
                else if(this.stringContains(this.message,sensorMessageStart) && this.useSensor)
                {
                    const sensors = this.readSensorsMessage(this.message);          
                    this.avarageLight = sensors.light;
                    this.avarageTemperature = sensors.tModule;
                    this.heatsinkTemperature = sensors.tHeatsink;  
                    this.overheat =  sensors.tHeatsink >= this.tHeatsinkMax;     
                }
                else if (this.stringContains(this.message,ivMessageStart))
                {
                    try{
                        await this.createSample(this.message, this.sampleName, this.sampleComment, this.avarageTemperature, this.avarageLight, this.lights);
                    }
                    catch(ex)
                    {
                        console.log(ex);
                        this.unlock("Failed create sample.Please try again.")
                    }

                    this.locked = false;
                }      
                
                //is still multimetr on ?
                if(this.isMultimetrOn 
                    && this.stringContains(this.message,sensorMessageStart)                     
                    && !this.stringContains(this.message,"Vx"))
                {
                    this.isMultimetrOn = false;
                }

                //make sure it is not in multimetr state
                if(this.stringContains(this.message,sensorMessageStart) && this.stringContains(this.message,"Vx"))
                {
                    this.isMultimetrOn = true;
                }
                
                
                this.message = "";
                if (msg) {
                    await this.onNewMessage(msg);
                }
            }
            else {
                this.message += msg;
            }

        },
        
        async handleCharacteristicValueChanged(event) {
            const value = event.target.value;
            const length = value.byteLength;
            if (length <= 0)
                return;
            let msg = String.fromCharCode([value.getUint8(0)]);

            for (var i = 1; i < length; i++) {
                msg += String.fromCharCode([value.getUint8(i)]);
            }
            await this.onNewMessage(msg);
            //console.log('Received ' + msg);
        },

        onTesterDisconnected(){
            console.log("on tester disconected");
            this.$data.deviceCharacteristic = null;            
        },

        async connect(){
            document.addEventListener('onTesterDisconnected',this.onTesterDisconnected);

            navigator.bluetooth.requestDevice({
                acceptAllDevices: true,
                optionalServices: [this.serviceUUID]
            })
            .then(device => {
                // Human-readable name of the device.
                console.log(device.name);
                device.ongattserverdisconnected = function () {                                        
                    console.log("Tester disconnected");
                    document.dispatchEvent(new CustomEvent('onTesterDisconnected', {}));
                };
                // Attempts to connect to remote GATT Server.
                return device.gatt.connect();
            })
            .then(server => {
                //console.log(server);
                return server.getPrimaryService(this.serviceUUID);
            })
            .then(service => {
                console.log(service);
                //return service.getCharacteristic
                return service.getCharacteristic(this.characteristicId);
            })
            .then(characteristic => characteristic.startNotifications())
            .then(characteristic => {
                characteristic.addEventListener('characteristicvaluechanged',
                    this.handleCharacteristicValueChanged);
                console.log('Notifications have been started.');
                this.deviceCharacteristic = characteristic;
            })
            .catch(error => {
                console.log(error);
                this.deviceCharacteristic = null;
            });
        },

        sendCommand(command){
             if (this.deviceCharacteristic == null) {
                console.log('writer is null');
            }
            else {
                this.locked = true;
                setTimeout( this.unlockByCommunicationError, 10000);
                console.log('send command ' + command );
                var value = Uint8Array.of(command);
                this.deviceCharacteristic.writeValue(value);                                
            }
        },

        StopMultimetr(){
            this.sendCommand(stopMultimetrCommand); 
        },

        unlock(error){
            if(!this.locked)
            {
                return;
            }

            this.locked = false;
            this.errorMessage =  error;           
        },

        unlockByCommunicationError(){
            this.unlock("Comunication error. Please try again.");
        },

        send(){
            this.errorMessage = "";
             if (this.deviceCharacteristic == null) {
                console.log('writer is null');
            }
            else {
                this.locked = true;
                setTimeout( this.unlockByCommunicationError, 10000);
                console.log('start PV test soon ...');
                var value = Uint8Array.of(31);
                this.deviceCharacteristic.writeValue(value);                
                if(this.$data.useSensor)
                {
                    this.planSensorReading();               
                }
            }
        },        

        stopSensorReading()
        {
            console.log("stop sensor reading");
            this.setSensorReadingAction(false);
            
            this.$data.lights = this.getSensorLights();
            this.$data.avarageLight = this.getAverageLight();
            this.$data.avarageTemperature = this.getAverageTemperature();

            console.log("lights to average:")
            console.log(this.$store.state.lights);

            console.log("temperatures to average:")
            console.log(this.$store.state.panelTemperature);

            this.clearLightsAction();
            this.clearPanelTemperaturesAction();
        },

        startSensorReading(){
            console.log("start sensor reading for average temperature and light");
            const testDuration = 1500;
            setTimeout(this.stopSensorReading, testDuration);
            this.setSensorReadingAction(true);
        },

        planSensorReading(){
            if(!this.getIsSensorConnected())
            {
                console.log("light sensor is not ready");
                return;
            }
            else{
                console.log("Planning to read sensor for average light and temperature");
                const flashDelay = 1000;
                setTimeout(this.startSensorReading, flashDelay);
            }
        },

        parseVoltageMultiplier(headerLine)
        {
            const searchTerm = 'Ux';
            const index = headerLine.indexOf(searchTerm);
            
            if(index<0)
                return 1;

            const vx = headerLine.substring(index + searchTerm.length, headerLine.length);
            const result = parseFloat(vx);
            return result;
        },

        getHeaderPartFloat(parts, searchTerm)
        {
            for(var i=0; i < parts.length; i++)
            {
                const part = parts[i];
                const index = part.indexOf(searchTerm);
                if(index >= 0)
                {
                    const vx = part.substring(index + searchTerm.length, part.length);
                    const result = parseFloat(vx);
                    return result;
                }
            }
            return null;
        },

        stringContains(text,searchTerm)
        {
            const index = text.indexOf(searchTerm);
            if(index >= 0)
                return true;
            
            return false;
        },

        readSensorsMessage(msg)
        {
            const parts = msg.split(";");
            const result = 
            {
                tModule : this.getHeaderPartFloat(parts,"Tm="),
                light : this.getHeaderPartFloat(parts,"E="),
                tHeatsink: this.getHeaderPartFloat(parts,"Tt="),                
            };
            return result;
        },

        parseHeader(headerLine)
        {
            const parts = headerLine.split(";");
            const result = 
            {
                voltageMultiplier : this.getHeaderPartFloat(parts,"Ux"),
                // eslint-disable-next-line no-unused-vars
                lightMultiplier : this.getHeaderPartFloat(parts,"Ex"),
                tModule1: this.getHeaderPartFloat(parts,"Tm1="),
                tModule2: this.getHeaderPartFloat(parts,"Tm2="),
                tHeatsink1: this.getHeaderPartFloat(parts,"Th1="),
                tHeatsink2: this.getHeaderPartFloat(parts,"Th2="),
                deviceId: this.getHeaderPartFloat(parts,"id="),
            };
            return result;
        },

        async createSample(msg, name, comment, temperature, light, lights){
            let rows = msg.trim().split("\n");
            //console.log(rows[0] + name + comment);
            //const voltageMultiplier = this.parseVoltageMultiplier(rows[0]);
            const headerData = this.parseHeader(rows[0]);
            const voltageMultiplier = headerData.voltageMultiplier;
            //remove first element with headers
            rows.splice(0,1);            
            const sampleData = rows.map(x=>{
                const columns = x.split(';');
                const point = {
                    position : parseInt(columns[0]),
                    i : calculator.parseIntWithOverflow(columns[1]),
                    u : voltageMultiplier && voltageMultiplier !=1 
                        ? voltageMultiplier * calculator.parseIntWithOverflow(columns[2])
                        : calculator.parseIntWithOverflow(columns[2]),
                    light : columns.length >= 4 
                        ? parseInt(columns[3]) 
                        : null
                }
                return point;
            });

            const sample = this.calculateSampleFromData(sampleData, headerData.lightMultiplier);
            
            if(sample === undefined)
            {
                console.log("failed to calculate data");
                return;
            }
            sample.name = name;
            sample.comment = comment;
            sample.temperature = temperature;
            sample.light = light;
            sample.lights = lights;

            sample.lightMultiplier = headerData.lightMultiplier;
            sample.tModule1 = headerData.tModule1;
            sample.tModule2 = headerData.tModule2;
            sample.tHeatsink1 = headerData.tHeatsink1;
            sample.tHeatsink2 = headerData.tHeatsink2;
            sample.deviceId = headerData.deviceId;

            if(sample.tModule1 && sample.tModule2)
            {
                sample.temperature = (sample.tModule1 + sample.tModule2) /2;                
            }

            if(sample.lightMultiplier && sample.sampleData.filter(x=>x.light).length > 0)
            {
                sample.lights = sample.sampleData.filter(x=>x.light).map(x=>x.light);
                sample.light = Math.round(this.getAverage(sample.lights));
            }

            //sample.folderId = this.$state.selectedFolder.rowKey;
            const sampleWithSTC = await this.calculateSTC(sample);
            console.log(sampleWithSTC);
            await this.addSampleAction(sampleWithSTC);
            return sampleWithSTC;
        },

        async calculateSTC(sample)
        {
            //debugger;
            if(sample.temperature === undefined || !sample.light)
                return sample;

            if(!sample.isc || !sample.uoc || !sample.wmpp)
                return sample;

            const measuredData = {
                temperature:sample.temperature, 
                light:sample.light,
                isc:sample.isc,
                uoc:sample.uoc,
                FF:sample.ff,
                wmpp:sample.wmpp,
                impp:sample.impp,
                umpp:sample.umpp,                
                };
            const calculatedData = await dataService.calculateSTC(measuredData);
            if(calculatedData)
            {
                sample.stcIsc = calculatedData.stcIsc;
                sample.stcUoc = Math.round( 10 * calculatedData.stcUoc )/10;
                sample.stcWmpp = calculatedData.stcWmpp;
                sample.rs = calculatedData.rs;
            }
            return sample;
        },

        calculateSampleFromData(testerData){
             if (!testerData || testerData.length == 0)
                return undefined;
                        
            var Uoc = this.getMaxOfArray(testerData.map(x => x.u)) / 1000;
            var mpp = this.GetMpp(testerData);
            var Isc = this.GetIsc(testerData, mpp);
            var FF = Isc * Uoc == 0 
                ? 0
                : Math.round((100 * mpp.Wmpp / (Isc * Uoc)) * 10)/10;            
            var sapleDataList = testerData.map(x => 
            {
                const point =
                {
                    position : x.position,
                    i : x.i / 1000,
                    u : x.u / 1000,
                };

                if(x.light)
                {
                    point.light = x.light;// * lightMultiplier; //it should be already calibrated and corrected by temperature at embeded side.
                }
                return point;
            }
            );

            sapleDataList.push(
            {
                position : this.getMaxOfArray(testerData.map(x => x.position)) + 1,
                i : Isc,
                u : 0
            });

            /* eslint-disable no-debugger */
            //debugger;
            /* eslint-enable no-debugger */
            var newId = uuidv4();
            var Wmpp = Math.round(mpp.Wmpp * 10) / 10;

            var sample = 
            {
                //Id = Guid.NewGuid(),    
                id : newId,           
                //Show = true,
                isc : Math.round(Isc * 100) / 100,
                uoc : Math.round(Uoc * 10) / 10,
                ff : FF,
                wmpp : Wmpp,
                impp : mpp.Impp,
                umpp : mpp.Umpp,
                date : new Date(),               
                temperature : testerData[0].Temperature,
                sampleData : sapleDataList
            };

            return sample;
        },
        GetIsc(testerData, mpp){
            const positionDelta = 5;
            const pos1_1 = testerData.length - 1;
            const pos1_2 = pos1_1 - positionDelta;

            const minVoltage = this.getMinOfArray(testerData.map(x => x.u)) / 1000;

            const targetU = 1000 * (mpp.Umpp - minVoltage) / 3  + 1000 * minVoltage;
            let targetPosition = pos1_2;
            for (let i=pos1_2; i > mpp.index; i--)
            {
                if(testerData[i].u > targetU)
                {
                    targetPosition = i;
                    break;
                }
            }                 
            const pos2_2 = targetPosition;            
            const pos2_1 = targetPosition + positionDelta;
            

            const x1 = this.getAverage(testerData.filter(x => x.position <= pos1_1 && x.position > pos1_2).map(x => x.u)) / 1000;
            const y1 = this.getAverage(testerData.filter(x => x.position <= pos1_1 && x.position > pos1_2).map(x => x.i)) / 1000;

            const x2 = this.getAverage(testerData.filter(x => x.position <= pos2_1 && x.position > pos2_2).map(x => x.u)) / 1000;
            const y2 = this.getAverage(testerData.filter(x => x.position <= pos2_1 && x.position > pos2_2).map(x => x.i)) / 1000;

            if (x2 - x1 == 0)
                return 0;

            const Isc = Math.round((y1 + (y2 - y1) * (-x1) / (x2 - x1)) * 1000) / 1000;

            return Isc;
        },
        GetMpp(testerData)
        {   
            let Wmpp = testerData[0].i * testerData[0].u;
            let mppIndex = 0;
            for (let j = 1; j < testerData.length; j++)
            {
                let w = testerData[j].i * testerData[j].u;                
                if (w > Wmpp)
                {                    
                    Wmpp = w;
                    mppIndex = j;
                }
            }
            const result =
            {
                Wmpp : Math.round( Wmpp / (1000 * 100) ) / 10 ,
                Impp : Math.round( testerData[mppIndex].i / 10) / 100,
                Umpp : Math.round( testerData[mppIndex].u / 100) / 10,
                index : mppIndex,
            };
            return result;
        },
        ToDoublelUnit(x)
        {
            return x / 1000;
        },


        getAverage(values){
            const sum = values.reduce((previous, current) => current += previous);
            const avg = sum / values.length;
            return avg;
        },
        getMaxOfArray(numArray) {
            return Math.max.apply(null, numArray);
        },
        getMinOfArray(numArray) {
            return Math.min.apply(null, numArray);
        },

    },    
    
}
</script>